(function(LoaderPresetsEnum, ComponentRegistryManager, Utilities) {
	let instance = null;

	class LoadersManager extends ComponentRegistryManager{

		constructor(){
			if(!instance){
				super();
				this._loadersMap = new Map();
				instance = this;
			}
			
			return instance;
		}
		
		/**
		 * PRIVATE
		 */
		_setActionsOnLoader(id, action){
			let promiseOnRelativeLoader = this._loadersMap.get(id);
			
			if(!promiseOnRelativeLoader){
				let promises = new Set().add(action);
				
				this._loadersMap.set(id, promises);
			}
			else{
				promiseOnRelativeLoader.add(action)
			}
		}
		
		_setLoaderAsEnable(id, blocker){
			let loaderInstance = this.getLoaderInstance(id);

			if(loaderInstance){
				this._setActionsOnLoader(id, () => { loaderInstance.setEnable(blocker); });
				this._manageLoaderPromises(id);
			}
		}
		
		_setLoaderAsDisable(id){
			let loaderInstance = this.getLoaderInstance(id);

			if(loaderInstance){
				this._setActionsOnLoader(id, () => { loaderInstance.setDisable(); });
				this._manageLoaderPromises(id);
			}
		}
		
		_manageLoaderPromises(id){
			let loaderActions = this._loadersMap.get(id);
			if(loaderActions){
				if(!loaderActions.has('__pending')){
					loaderActions.add('__pending');
					for (let action of loaderActions) {
						if(Utilities.isFunction(action)){
							action();
							loaderActions.delete(action);
						}
					}
					loaderActions.delete('__pending');
				}
			}
		}
		
		/**
		 * PUBLIC
		 */
		
		registerLoaderById(instance, id){
			this.register(instance, id);
		}
		
		deRegisterLoaderById(id){
			this.deRegister(id);
		}
		
		getLoaderInstance(id){
			return this.getComponentInstance(id);
		}
		
		setLoaderValueMode(id, valueMode){
			let loaderInstance = this.getLoaderInstance(id);

			if(loaderInstance){
				this._setActionsOnLoader(id, () => { loaderInstance.setValueMode(valueMode); });
				this._manageLoaderPromises(id);
			}
		}
		
		notifyProcessStarted(id, blocker, referringPromise){
			if(referringPromise && referringPromise.then){
				referringPromise.then(() => {
					this._setLoaderAsDisable(id);
				}, () => {
					this._setLoaderAsDisable(id);
				});
			}
			this._setLoaderAsEnable(id, blocker);
		}
		
		notifyProcessFinished(id){
			this._setLoaderAsDisable(id);
		}
		
		static getInstance(){
			return new LoadersManager();
		}
	}
	
	window.LoadersManager = LoadersManager;
}(window.LoaderPresetsEnum, window.ComponentRegistryManager, window.Utilities));